// src/v3/actions/lock.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var LockIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "LockIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M19.5 8.66667H16.5V6.44444C16.5 5.2657 16.0259 4.13524 15.182 3.30175C14.3381 2.46825 13.1935 2 12 2C10.8065 2 9.66193 2.46825 8.81802 3.30175C7.97411 4.13524 7.5 5.2657 7.5 6.44444V8.66667H4.5C4.10218 8.66667 3.72064 8.82275 3.43934 9.10058C3.15804 9.37841 3 9.75523 3 10.1481V20.5185C3 20.9114 3.15804 21.2883 3.43934 21.5661C3.72064 21.8439 4.10218 22 4.5 22H19.5C19.8978 22 20.2794 21.8439 20.5607 21.5661C20.842 21.2883 21 20.9114 21 20.5185V10.1481C21 9.75523 20.842 9.37841 20.5607 9.10058C20.2794 8.82275 19.8978 8.66667 19.5 8.66667ZM9 6.44444C9 5.65862 9.31607 4.90498 9.87868 4.34931C10.4413 3.79365 11.2044 3.48148 12 3.48148C12.7956 3.48148 13.5587 3.79365 14.1213 4.34931C14.6839 4.90498 15 5.65862 15 6.44444V8.66667H9V6.44444ZM19.5 20.5185H4.5V10.1481H19.5V20.5185Z"
  }
) });

export {
  LockIcon
};
